
import { defineComponent } from "vue"
import ArrowLeft from "./icons/ArrowLeft.vue"
import ArrowRight from "./icons/ArrowRight.vue"
import Copy from "./icons/Copy.vue"

export default defineComponent({
	name: "ConvButton",
	components: {
		ArrowLeft,
		ArrowRight,
		Copy
	},
	props: {
		icon: String,
		color: String
	}
})
